import AutoCompleteUIDTO from "../dto/AutoCompleteUIDTO";
import ApiResponse from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/ApiResponse";
import PagedResult from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/PagedResult";
import GenericCrudService from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/GenericCrudService";
import HttpClient from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/HttpClient";
import KnowledgeBase from "../models/KnowledgeBase";

class KnowledgeBaseService extends GenericCrudService<KnowledgeBase> {
  path: string;

  constructor(path: string) {
    super(path);
    this.path = path;
  }

  findKnowledgeBaseCategories(): Promise<ApiResponse<AutoCompleteUIDTO[]>> {
    return HttpClient.get(`${this.basePath}/knowledge-base-categories`);
  }

  findKnowledgeBaseCodes(): Promise<ApiResponse<AutoCompleteUIDTO[]>> {
    return HttpClient.get(`${this.basePath}/knowledge-base-codes`);
  }

  findByCategory(page: number, pageSize: number, category: string): Promise<ApiResponse<PagedResult<KnowledgeBase>>> {
    let query = `${this.basePath}/find-by-category?page=${page}&pageSize=${pageSize}&category=${category}`;
    return HttpClient.get(query, true);
  }

  findByCode(page: number, pageSize: number, code: string): Promise<ApiResponse<PagedResult<KnowledgeBase>>> {
    let query = `${this.basePath}/find-by-code?page=${page}&pageSize=${pageSize}&code=${code}`;
    return HttpClient.get(query, true);
  }
}

export default new KnowledgeBaseService("/ensolvers-ops/knowledge-base");
